import axios from 'axios';
import { setStoredLocale, setStoredStartPage } from './uiPreferences';

const url = () => `${process.env.REACT_APP_API_URL}/user-preferences`;

// The signed-in user's own preferences, saved to their account so they follow them across devices.
export const fetchUserPreferences = () => axios.get(url()).then(({data}) => data || {}).catch(() => null);

export const saveUserPreferences = (patch) => axios.put(url(), patch).catch(e => {
    console.log(e);
    return null;
});

// The user picked a language: apply it, remember it in this browser and on the account.
export const chooseLocale = (locale, switchLanguage) => {
    setStoredLocale(locale);
    switchLanguage({locale});
    saveUserPreferences({locale});
};

export const chooseStartPage = (path) => {
    setStoredStartPage(path);
    return saveUserPreferences({startPage: path || null});
};

// The few pages offered as a start page. Anything else saved (an old or removed page) falls
// back to the dashboard, so a changed link can never strand the user after login.
export const DEFAULT_START_PAGE = '/my-dashboard';
export const START_PAGES = [
    {value: DEFAULT_START_PAGE, id: 'sidebar.dashboard', label: 'Dashboard'},
    {value: '/chat?id=&tab=2', id: 'sidebar.chats', label: 'Chats'},
    {value: '/reports', id: 'sidebar.reports', label: 'Reports'}
];

export const resolveStartPage = (path) =>
    START_PAGES.some(page => page.value === path) ? path : DEFAULT_START_PAGE;

// First supported language among the browser's preferred ones ('pl-PL' -> 'pl').
export const browserLocale = (supported) => {
    const list = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''])
        .map(code => String(code).toLowerCase().split('-')[0]);
    return list.find(code => supported.includes(code)) || null;
};
